module.exports = __webpack_public_path__ + "img/algar.becff0a0.png";